<template >
  <splash></splash>
  <div class="container mt-1" dir="rtl">

  <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto; top:5.5vw" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="background-image: url('/img/gaz.png'); background-size: cover;
height: 40vw;    margin: 0.5vw;
">
        <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);" class="rounded p-2">

        <center  style="display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;" class="card bg-white   rounded mb-2 px-4">

            <h5 style="font-size: 1vw !important; margin: 0.5vw;">دسترسی سریع</h5>
                          <button class="btn btn-primary btn-submit-1 btn-auto-size" style="height: 2.5vw !important; margin: .2vw;font-size: 0.8vw;" @click="clearBrowserCache">پاک کردن کش مرورگر</button>

        </center>
        <div v-if="!$cookies.isKey('is_process_manager')" class="m-5" style="padding: 0.5vw;border: solid 1px white;border-radius: 0.5vw;margin-top: 2.4vw !important;">
          <h6 style="font-size: 0.9vw !important;border-bottom: solid 1px white;padding: 0vw 0.5vw 0.5vw 0.5vw;color: white;">پایش برنامه بهره وری بخش اقتصادی</h6>
        <div  class="d-flex justify-content-center">
          
          <WorkSheet  link="" title="پایش"/>
        </div>
          </div>

           <div v-if="!$cookies.isKey('is_process_manager')" class="m-5" style="padding: 0.5vw;border: solid 1px white;border-radius: 0.5vw;">
          <h6 style="font-size: 0.9vw !important;border-bottom: solid 1px white;padding: 0vw 0.5vw 0.5vw 0.5vw;color: white;">برنامه ریزی و پایش بهره وری خدمات دولت</h6>
        <div  class="d-flex justify-content-center">
          
          <WorkSheet link="/productivity_improvement_program" title="برنامه ریزی"/>
          <WorkSheet link="" title=" پایش "/>
        </div>
          </div>

           <div v-if="!$cookies.isKey('is_process_manager')" class="m-5" style="padding: 0.5vw;border: solid 1px white;border-radius: 0.5vw;">
          <h6 style="font-size: 0.9vw !important;border-bottom: solid 1px white;padding: 0vw 0.5vw 0.5vw 0.5vw;color: white;">چرخه مدیریت بهره وری</h6>
        <div  class="d-flex justify-content-center">
          
          <WorkSheet link="/executive_elements" title="کاربرگ 1"/>
          <WorkSheet link="/Financial_management_and_productivity/Determining_the_mission" title="کاربرگ 2"/>
          <WorkSheet link="/problem_analysis/Problem_identification" title="کاربرگ 3"/>
          <WorkSheet link="/problem_analysis/Prioritizing_issue" title="کاربرگ 4"/>
          <WorkSheet link="/problem_analysis/The_root_causes_of_the_problem" title="کاربرگ 5"/>
          <WorkSheet link="/problem_analysis/Definition_of_basic_measures" title="کاربرگ 6"/>
          <WorkSheet link="/problem_analysis/device_monitoring_and_care" title="کاربرگ 7"/>
          <WorkSheet link="/Impact_Assessment" title="کاربرگ 8"/>
        </div>
          </div>
          
        <div v-else class="d-flex justify-content-center">
          <WorkSheet link="/process/map" title="نقشه های فرآیندی"/>
          <WorkSheet link="/process/id" title="شناسنامه فرآیندی"/>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import Splash from "@/components/Splash/Splash";
import WorkSheet from "@/components/Icons/WorkSheet.vue";
import BackIcon from "@/components/Icons/BackIcon.vue";

export default {
  name: "HomeView",

  components: {
    BackIcon,
    WorkSheet,
    Sidebar,
    Splash,
  },

  methods: {
    async clearBrowserCache() {
      try {
        // پاک کردن Service Workers
        if ("serviceWorker" in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (const registration of registrations) {
            await registration.unregister();
          }
        }

        // پاک کردن Cache Storage
        if ("caches" in window) {
          const names = await caches.keys();
          for (const name of names) {
            await caches.delete(name);
          }
        }

        // رفرش صفحه بدون پارامتر قدیمی
        window.location.reload();

        return true;

      } catch (error) {
        console.error("خطا در پاک کردن کش:", error);
        return false;
      }
    }
  }
};
</script>

